import Repository from "../Repository";

const resource = "/product/seat";

export default {
  async get(seat_uuid) {
    return Repository.get(`${resource}/${seat_uuid}`);
  },

  async createSeat(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
